module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src259009759/src/src/app/common/auto-logout/auto-logout.component.html
// module id = ../../../../../src/app/common/auto-logout/auto-logout.component.html
// module chunks = main